import React from 'react';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { OnlineViewers } from './OnlineViewers';
export function Hero() {
  return <div className="pt-24 pb-12 px-4 sm:px-6 bg-gradient-to-b from-white to-cream-50" data-id="element-104">
      <div className="max-w-5xl mx-auto text-center" data-id="element-105">
        {/* Online Viewers */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="flex justify-center mb-6" data-id="element-106">
          <OnlineViewers data-id="element-107" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex items-center justify-center mb-8" data-id="element-108">
          <Leaf className="w-12 h-12 text-amber-600 mr-4" data-id="element-109" />
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-navy-900 uppercase tracking-tight" data-id="element-110">
            Dormir Sin Pensar
          </h1>
          <Leaf className="w-12 h-12 text-amber-600 ml-4 transform scale-x-[-1]" data-id="element-111" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl sm:text-2xl md:text-3xl text-amber-700 font-medium mb-12 max-w-4xl mx-auto" data-id="element-112">
          Tu protocolo de 14 noches para apagar la mente y recuperar el descanso
          que mereces.
        </motion.p>

        {/* Countdown Timer */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-113">
          <CountdownTimer data-id="element-114" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mb-8" data-id="element-115">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-116">
            ¿Y si el estrés no fuera el problema?
          </h2>
          <p className="text-lg sm:text-xl text-navy-700 mb-4 max-w-3xl mx-auto" data-id="element-117">
            ¿Y si el verdadero enemigo... fuera no tener un botón de pausa?
          </p>
          <p className="text-base sm:text-lg text-navy-600 max-w-3xl mx-auto leading-relaxed mb-6" data-id="element-118">
            Te acuestas cansada, pero tu mente recién empieza. Repasa
            pendientes, conversaciones, lo que falta... Y cuando miras el reloj:{' '}
            <span className="font-semibold" data-id="element-119">
              "Si no me duermo ya, mañana estoy destruida."
            </span>
          </p>
          <p className="text-base sm:text-lg text-navy-700 italic max-w-2xl mx-auto" data-id="element-120">
            Pero algo dentro de ti... ya sabe que necesita un cambio. Uno que no
            dependa de pastillas, de distracciones o de "aguantar un poco más".
          </p>
        </motion.div>
      </div>
    </div>;
}